// 所有汇入汇款申报状态
export const declareStatusMap = {
  WAIT: '审核中',
  HOLD: '审核中',
  REJECT: '申报拒绝',
  PASS: '申报完成',
  PASS1: '审核中',
  PASS2: '申报完成',
  REFUND: '已退汇'
}

// 汇款人企业性质
export const payBusinessTypeMap = {
  1: '贸易公司',
  2: '咨询公司',
  3: '控股公司',
  4: '互联网公司',
  5: '电子商务公司'
}

// 与汇款人关系
export const relationshipMap = {
  1: '同名公司',
  2: '贸易往来',
  3: '控股公司',
  4: '业务关联',
  5: '投资公司'
}
